import * as d3 from 'd3-selection'
import * as shape from 'd3-shape'

const arc = shape.arc()

/*
 * Transforms path elements between shapes that resemble a bar and shapes
 * that resemble a slice of a pie (or a donut)
 */
class PieBarTransformer {

  constructor (options) {
    this.d = options.d // Actual data of the pie slice
    this.styles = options.styles

    // Properties of the bar
    this.width = options.width + 2 // borders
    this.height = options.height + 2
    this.x = options.x - 1 // Offset for the border
    this.bottomOfBar = options.y + this.height

    this.path = options.path // Path element for the drawing
    this.use = options.use // Use element that references the path
  }

  transform (t) {
    let radius = parseInt((this.styles.outerRadius / 2 / Math.min(1, t + 1e-3)))
      , step = Math.cos(t * Math.PI / 2) // Stepping factor. Basically inverse of t (i.e. `1 - t`), but smoother
      , xx = parseInt(-radius + step * (this.x + this.width) + (1 - step) * (this.d.dimensions.width + this.styles.outerRadius) / 2)
      , yy = parseInt((step * this.bottomOfBar) + (1 - step) * this.d.dimensions.height / 2)
      , xOffset = (1 - step) * this.d.dimensions.x
      , yOffset = (1 - step) * this.d.dimensions.y

    let f = {
      innerRadius: Math.max(this.styles.innerRadius, (radius - this.width / (2 - step)) * step),
      outerRadius: Math.max(this.styles.outerRadius, radius),
      startAngle: step * (Math.PI / 2 - this.height / radius) + (1 - step) * this.d.slice.startAngle,
      endAngle: step * (Math.PI / 2) + (1 - step) * this.d.slice.endAngle
    }

    if (t > .75) {
      // Start padding once it resembles the correct slice. Otherwise
      // padAngle throws off the initial bar representation
      f.padAngle = this.styles.padAngle
    }

    let pathStr = arc(f)

    if (t < .9) {
      // Remove excess decimals which cause issues in chrome/canary
      pathStr = pathStr.replace(/\d+\.\d+/g, s => parseFloat(s).toFixed(0))
    }

    this.use.attr('transform', `translate(${xx + xOffset}, ${yy + yOffset})`)

    this.path.attr('d', pathStr)
  }

}

export default PieBarTransformer
